import React from 'react';

const CurrencyLogo = ({ className = '', width = 18, height = 12 }) => {
  return (
    <img
      src="/currLogo.png"
      alt="Currency"
      className={className}
      style={{ width, height, objectFit: 'contain', display: 'inline-block', verticalAlign: 'middle' }}
    />
  );
};

export default CurrencyLogo;
